import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CaptureReceiptPage } from './CaptureReceiptPage';

const captureSearchSchema = z.object({
  // Reserved for a future chat entry point; unused by this capture UI.
  returnTo: z.string().optional(),
  // Presence enables the on-screen debug panel (read via window.location.search).
  debug: z.string().optional(),
});

export const Route = createFileRoute('/_protected/receipts/capture/')({
  validateSearch: captureSearchSchema,
  component: CaptureReceiptPage,
});
